module.exports = __webpack_public_path__ + "static/gallery-comunidades-hispanas-1-72e77ad31aff59426657fd37128315f7.jpg";